import { Modal } from "antd";
import Back from "Components/Back";
import { useGetSingleCreditManagementQuery } from "hooks/CreditManagement/useGetSingleCreditManagementQuery";
import { useState } from "react";
import { useParams } from "react-router-dom";
import ApproveInterface from "./forms/ApproveInterface";
import ReviewInterface from "./forms/ReviewInterface";
import DeclineInterface from "./forms/DeclineInterface";

const Header = () => {
  const { id } = useParams();
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const { data, isPending } = useGetSingleCreditManagementQuery(`${id}`);
  const [active, setActive] = useState("");

  return (
    <div className="mt-[20px] border-[1px] border-[#eeeeee] p-3 rounded-[10px] mb-3">
      <div className="flex items-center justify-between">
        <span className="flex gap-2 items-center">
          <Back />
          <div className="flex gap-2 items-center ml-4">
            <span className="text-primary-foreground">Credit Management</span>
            <Right />
            <span className="text-primary-foreground">Details</span>
          </div>
        </span>
        <span className="">
          <div className="flex items-center justify-between">
            <span className="flex flex-row gap-1">
              {data?.data?.status === "pending" && (
                <button
                  onClick={() => {
                    setIsAddModalOpen(true);
                    setActive("in-review");
                  }}
                  className="text-[#414141] rounded-md bg-[#FFF5F0] p-3 text-[14px]"
                >
                  In Review
                </button>
              )}
              {data?.data?.status === "pending" ||
                (data?.data?.status === "in_review" && (
                  <button
                    onClick={() => {
                      setIsAddModalOpen(true);
                      setActive("decline");
                    }}
                    className="text-[#414141] rounded-md bg-[#FFF5F0] p-3 text-[14px]"
                  >
                    Decline
                  </button>
                ))}
              {data?.data?.status === "in_review" && (
                <button
                  onClick={() => {
                    setIsAddModalOpen(true);
                    setActive("approve");
                  }}
                  className="text-[#414141] rounded-md bg-[#f3f3f3] p-3 text-[14px]"
                >
                  Approve
                </button>
              )}
            </span>
          </div>
        </span>
        <Modal
          title={
            <span className="mt-2">{`${
              active === "approve"
                ? "Approve Application"
                : active === "in-review"
                ? "Application In Review"
                : active === "decline"
                ? "Decline Application"
                : ""
            }`}</span>
          }
          open={isAddModalOpen}
          onCancel={() => setIsAddModalOpen(false)}
          footer={null}
        >
          {active === "approve" && (
            <ApproveInterface setIsAddModalOpen={setIsAddModalOpen} />
          )}
          {active === "in-review" && (
            <ReviewInterface setIsAddModalOpen={setIsAddModalOpen} />
          )}
          {active === "decline" && (
            <DeclineInterface setIsAddModalOpen={setIsAddModalOpen} />
          )}
        </Modal>
      </div>
    </div>
  );
};

export default Header;

const Right = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="size-4 text-primary-foreground"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m8.25 4.5 7.5 7.5-7.5 7.5"
      />
    </svg>
  );
};
